export default "__VITE_ASSET__7hb0f2f0__"